import axios from "axios";
import store from "../store";
import router from "../router";
import endpoints from "@/utils/endpoints";

export let http_fibercloud = axios.create({
  // baseURL: process.env.ROOT_API + '/8081',
  baseURL: endpoints.FIBER_API_URL,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("auth_token")
  }
});

export let http_fibercloud_complete_request = axios.create({
  headers: {
    Authorization: "Bearer " + localStorage.getItem("auth_token")
  }
});

http_fibercloud.interceptors.request.use(
  config => interceptRequest(config),
  error => {
    return Promise.reject(error);
  }
);

function interceptRequest(config) {
  let token = localStorage.getItem("auth_token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  if (["put"].includes(config.method)) {
    config.data = cleanJSON(config.data);
  }

  return config;
}

http_fibercloud.interceptors.response.use(
  response => {
    return response;
  },

  error => {
    //Check if user is authenticated
    if (
      error &&
      error.response &&
      error.response.status === 401
    ) {
      store.dispatch("LOGOUT");
      router.push("/login");
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export let http_weezie_fiber = axios.create({
  baseURL: endpoints.FIELD_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",

    Authorization: "Bearer " + localStorage.getItem("auth_token")
  }
});

http_weezie_fiber.interceptors.request.use(
  config => interceptRequest(config),
  error => {
    return Promise.reject(error);
  }
);

/**
 * Add json cleaner to set undefined/null values to empty string.
 * This is to prevent axios(json to string using jsonify) from removing those keys
 * when converting json paylod to string.
 */
function cleanJSON(json) {
  for (let key in json) {
    if (json[key] === undefined || json[key] === "") {
      json[key] = null;
    } else if (typeof json[key] === "object") json[key] = cleanJSON(json[key]);
  }
  return json;
}

export let http_field_license = axios.create({
  baseURL: endpoints.FIELD_API_URL
});

export let http_fibercloud_license = axios.create({
  baseURL:  endpoints.FIBER_API_URL
});



// WEBPACK FOOTER //
// ./src/api/index.js